export const RESIZER_CLASS_NAME = 'resizer';
